module.exports = __webpack_public_path__ + "img/expand_more-24px.f02bf01a.svg";